<template>
  <div class="column is-10 container">
    <!-- <h1 class="title is-1 has-text-centered">{{ $t("Partners.Title") }}</h1> -->
    <div :class="{'multiple-slides': partners.length > 1}">
      <vue-agile :nav-buttons="false" :infinite="false">
        <div
          class="slide columns is-multiline is-gapless"
          v-for="(items, idx_i) in partners"
          :key="idx_i"
        >
          <div
            v-for="(partner, idx_p) in items"
            :key="idx_p"
            class="is-3 is-6-mobile column"
            @click="handleClick(partner)"
          >
            <figure>
              <img
                :src="$store.state.imgBase + partner.Image"
                :alt="partner.Cultures[$store.state.language].Name"
                :title="partner.Cultures[$store.state.language].Name"
              />
            </figure>
          </div>
        </div>
      </vue-agile>
    </div>
    <div class="has-text-right">
      <router-link
        v-if="formPage"
        :to="'/' + $store.state.language + '/' + formPage"
        tag="button"
        class="button is-primary is-medium"
      >
        <span
          ><strong>{{ $t("Partners.GetInTouch") }}</strong></span
        >
        <span class="icon is-small">
          <font-awesome-icon :icon="icons.right" />
        </span>
      </router-link>
    </div>
    <lightbox
      :show="showLightbox"
      @onclose="showLightbox = false"
      :item="item"
    ></lightbox>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'
import { arrayChunk } from '@/mixins/arrayChunk.js'
import lightbox from '@/components/Lightbox.vue'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'partners',
  mixins: [arrayChunk],
  data () {
    return {
      showLightbox: false,
      item: {},
      icons: {
        right: faChevronRight
      }
    }
  },
  props: {
    ignore: {
      type: Array,
      default: () => []
    }
  },
  components: {
    VueAgile,
    lightbox
  },
  computed: {
    partners () {
      // var partners = this.filtered || []
      // for (var i = partners.length - 1; i > 0; i--) {
      //   const j = Math.floor(Math.random() * (i + 1));
      //   [partners[i], partners[j]] = [partners[j], partners[i]]
      // }
      // // console.log(this.filtered)
      // return this.arrayChunk(partners, 8)
      return this.arrayChunk(this.filtered, 8)
    },
    filtered () {
      var self = this
      var tmp = []
      self.$store.state.partners.forEach((partner) => {
        if (
          !this.ignore.includes(partner.ID) &&
          partner.Cultures &&
          partner.Cultures.hasOwnProperty(self.$store.state.language)
        ) {
          tmp.push(partner)
        }
      })
      return tmp
    },
    formPage () {
      var self = this
      var form = false
      for (var i = 0; i < self.$store.state.sitemap.length; i++) {
        if (
          self.$store.state.sitemap[i].Cultures[self.$store.state.language] &&
          self.$store.state.sitemap[i].Cultures[self.$store.state.language].Content.Html.indexOf('<contactform></contactform>') > -1
        ) {
          form = self.$store.state.sitemap[i].ID
          break
        }
      }
      return form
    }
  },
  methods: {
    handleClick: function (partner) {
      var self = this
      self.item = {
        Title: partner.Cultures[self.$store.state.language].Name,
        Text: partner.Cultures[self.$store.state.language].Text,
        Image: self.$store.state.imgBase + partner.Image,
        Link: partner.Link
      }
      self.showLightbox = true
    }
  }
}
</script>

<style lang="scss" scoped>
.slide {
  > .column {
    border-right: 1px solid $grey-lighter;
    overflow: hidden;
    padding: 35px 0px !important;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    vertical-align: top;

    &:nth-child(4),
    &:nth-child(8) {
      border-right: 0;
    }

    &:nth-child(n + 1):nth-child(-n + 4) {
      border-bottom: 1px solid $grey-lighter;
    }

    > figure {
      margin-bottom: 0 !important;
      img {
        width: auto;
        height: 86px;
      }
    }
  }
  @media screen and (max-width: $bp-tablet - 1px) {
    > .column {
      > figure {
        margin-bottom: 0 !important;

        img {
          height: 72px;
        }
      }

      &:nth-child(even) {
        border-right: 0;
      }
      &:nth-child(n + 1):nth-child(-n + 6) {
        border-bottom: 1px solid $grey-lighter;
      }
      &:last-child {
        border-bottom: 0 !important;
      }
    }
  }
}
/deep/.agile {
  .agile__actions {
    justify-content: center;
    min-height: 20px;
    padding: 1rem 0;
    .agile__dots {
      list-style: none;
      margin-left: 0;
      margin-top: 0;
      .agile__dot {
        > button {
          border: none;
          background-color: $grey-lighter;
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }
        + .agile__dot {
          margin-left: 5px;
          margin-top: 0px;
        }
        &.agile__dot--current {
          > button {
            background-color: $info;
          }
        }
      }
    }
  }
}

:not(.multiple-slides){
  /deep/.agile{
    .agile__actions{
      .agile__dots {
        display: none;
      }
    }
  }
}
</style>
